import { curves } from '../constants';

import { TPolygonDotsShapes } from './../types';

const addcl = (point: number): number => point + curves.back;
const remcl = (point: number): number => point + curves.front;

const buildBaseFigure = (d: TPolygonDotsShapes) => {
    const result = [];

    // start point
    result.push(`M${d.left.x} ${d.left.top}`);
    // line from the start point to the right top point
    result.push(`L${d.right.x} ${d.right.top}`);
    // curve from the top right point to the right bottom point
    result.push(`C${addcl(d.right.x)} ${d.right.top} ${addcl(d.right.x)} ${d.right.bottom} ${d.right.x} ${d.right.bottom}`);
    // line from the right bottom point to the left bottom point
    result.push(`L${d.left.x} ${d.left.bottom}`);
    // curve from the left bottom point to the start point
    result.push(`C${remcl(d.left.x)} ${d.left.bottom} ${remcl(d.left.x)} ${d.left.top} ${d.left.x} ${d.left.top}`);

    return result;
};

export default buildBaseFigure;
